import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import CompositeButton from "../../ui/components/CompositeButton";
import CloseMapCharacterMenuEvent from "../event/CloseMapCharacterMenuEvent";
import MapCharacterInteractionEvent from "../event/MapCharacterInteractionEvent";
import MapCharacterDefinition from "../model/MapCharacterDefinition";
import MapLocationDefinition from "../model/MapLocationDefinition";
import MapModel from "../model/MapModel";

export default class MapLocationCharacterMenuMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MapModel} mapModel 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     * @param {AssetLibrary} assetLibrary 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mapModel, languagePack, mediatorManager, assetLibrary) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._mapModel = mapModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._assetLibrary = assetLibrary;

        /** @type {MapLocationDefinition} */
        this._location = this.getCustomData().location;

        // /** @type {MapLocationCharacterMenuItemMediator} */
        // this._menuItemMediators = [];
        /** @type {Array<CompositeButton>} */
        this._menuItems = [];

        this._handleMenuItemBound = this._handleMenuItem.bind(this);
    }

    initialize() {
        super.initialize();

        this._initializeItemMediators();
    }

    destroy() {
        super.destroy();

        for (let i = 0; i < this._menuItems.length; i++) {
            const menuItem = this._menuItems[i];
            menuItem.removeEventListener('click', this._handleMenuItemBound);
            menuItem.destroy();
        }
    }

    show() {
        const charactersInLocation = this._mapModel.getActiveCharactersForLocation(this._location);
        for (let i = 0; i < Math.min(charactersInLocation.length, this._menuItems.length); i++) {
            const character = charactersInLocation[i];
            const menuItem = this._menuItems[i];

            menuItem.setLabel(this._languagePack.getText(`map.characters.${character.id}.action`));
            menuItem.setData({
                character,
            });

            const characterImage = this._assetLibrary.getAsset(character.imageId);
            const characterBitmap = new createjs.Bitmap(characterImage);
            const characterBitmapBounds = characterBitmap.getBounds();
            characterBitmap.x = -characterBitmapBounds.width * .5;
            characterBitmap.y = -characterBitmapBounds.height * .5;

            menuItem.characterContainer.removeAllChildren();
            menuItem.characterContainer.addChild(characterBitmap);

            menuItem.setVisible(true);
        }

        for (let i = charactersInLocation.length; i < this._menuItems.length; i++) {
            const menuItem = this._menuItems[i];
            menuItem.setData(null);
            menuItem.setVisible(false);
        }
    }

    hide() {
        for (let i = 0; i < this._menuItems.length; i++) {
            const menuItem = this._menuItems[i];
            menuItem.setData(null);
            menuItem.setVisible(false);
        }
    }

    _initializeItemMediators() {
        for (let i = 0; i < MapLocationCharacterMenuMediator.ITEM_COUNT; i++) {
            const labelSkin = this._target[`label${i + 1}`];
            const imageSkin = this._target[`image${i + 1}`];
            
            const compositeButton = new CompositeButton();
            compositeButton.addSkinAsButton(labelSkin);
            compositeButton.addSkinAsButton(imageSkin);
            compositeButton.characterContainer = imageSkin.characterContainer;

            compositeButton.setVisible(false);

            compositeButton.addEventListener('click', this._handleMenuItemBound);

            this._menuItems.push(compositeButton);
        }
    }

    _handleMenuItem(evt) {
        /** @type {MapCharacterDefinition} */
        const character = evt?.target?.getData()?.character;
        const mapNodeInteractionEvent = new MapCharacterInteractionEvent(MapCharacterInteractionEvent.ENTER, character);
        this.dispatch(mapNodeInteractionEvent.type, { data: mapNodeInteractionEvent });

        this.dispatch(CloseMapCharacterMenuEvent.CLOSE_ALL);
    }
}

MapLocationCharacterMenuMediator.ITEM_COUNT = 2;